import { InstanceScreen } from 'component/navigation/instance';

export default function VideoVotingDebugScreen() {
    return <InstanceScreen screenKey='debug' />;
}
